import React, { useEffect, useState, useRef } from "react";
import "./TrainingPage.css";
import NavbarCapacita from "../../components/NavbarCapacita/NavbarCapacita";
import { validateToken, getTrainingVideos } from "../../services/AuthService"
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/footer/Footer';
import VideoCard from "../../components/videoCard/VideoCard";


const TrainingVideoList = () => {
    const [videos, setVideos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const videosPerPage = 8;

    const token = localStorage.getItem("site")
    const [isValidate, setIsValidate] = useState(false)

    const navigate = useNavigate();
    const timeoutRef = useRef()

    useEffect(() => {
        getTrainingVideos()
            .then(response => {
                setVideos(Array.isArray(response.data.content) ? response.data.content : []);
            })
            .catch(error => {
                console.error("Error fetching videos:", error);
                setVideos([]);
            });
    }, []);

    useEffect(() => {
        if (token) {
            validateToken(token)
                .then((response) => {
                    if (response.status === 200) setIsValidate(true)
                })
                .catch((err) => {
                    if (err.response && err.response.status) {
                        setIsValidate(false)
                        timeoutRef.current = setTimeout(() => {
                            navigate("/login")
                        }, 4000)
                    }
                })
        } else {
            setIsValidate(false)
            navigate("/login")
        }
    }, [token, navigate])

    const indexOfLastVideo = currentPage * videosPerPage;
    const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
    const currentVideos = videos.slice(indexOfFirstVideo, indexOfLastVideo);

    const totalPages = Math.ceil(videos.length / videosPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="app-container">
            <NavbarCapacita />
            <div className="capacitaciones-title">Capacitaciones</div>
            <div className="video-grid">
                {currentVideos.map((video, index) => (
                    <VideoCard
                        key={video.id}
                        id={video.id}
                        url={video.url}
                        title={video.title}
                        index={indexOfFirstVideo + index}
                    />
                ))}
            </div>
            <div className="pagination">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
                    <button key={number} onClick={() => paginate(number)} className={currentPage === number ? 'active' : ''}>
                        {number}
                    </button>
                ))}
            </div>
            <Footer/>
        </div>
    );
};

export default TrainingVideoList;